import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastProvider, useToast } from "../components/Toast";
import AdminSidebar from "../components/AdminSidebar";
import BlogForm, {
  EMPTY_BLOG_FORM,
  buildBlogFormData,
  validateBlogForm,
} from "../components/BlogForm";
import { createBlog } from "../../services/api";

const AddBlogInner = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY_BLOG_FORM);
  const [faqs, setFaqs] = useState([]);
  const [headImageFile, setHeadImageFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    const error = validateBlogForm(form);
    if (error) {
      toast(error, "error");
      return;
    }
    setSaving(true);
    try {
      await createBlog(buildBlogFormData(form, faqs, headImageFile));
      toast("Blog post created!", "success");
      setTimeout(() => navigate("/admin/blogs"), 900);
    } catch (e) {
      toast(e.response?.data?.message || "Error creating blog", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar
        section="blogs"
        onSectionChange={(id) => navigate("/admin", { state: { section: id } })}
      />
      <div className="admin-content">
        <div className="admin-section active">
          <div className="admin-header">
            <div className="admin-title">➕ New Blog Post</div>
            <button
              className="btn-secondary btn-sm"
              onClick={() => navigate("/admin/blogs")}
            >
              ← Back to Blogs
            </button>
          </div>

          <div className="admin-card" style={{ maxWidth: 900, padding: 24 }}>
            <BlogForm
              form={form}
              setForm={setForm}
              faqs={faqs}
              setFaqs={setFaqs}
              headImageFile={headImageFile}
              setHeadImageFile={setHeadImageFile}
              existingHeadImage={null}
              toast={toast}
            />

            <div style={{ display: "flex", gap: 12, marginTop: 28 }}>
              <button
                className="btn-primary"
                onClick={handleSubmit}
                disabled={saving}
              >
                {saving ? "Saving…" : "Publish Blog Post"}
              </button>
              <button
                className="btn-secondary"
                onClick={() => navigate("/admin/blogs")}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddBlogPage = () => (
  <ToastProvider>
    <AddBlogInner />
  </ToastProvider>
);

export default AddBlogPage;
